<template>
  <div id="oomPage">
    <div class="tRow">
      <MiniMenu :config="config"/>
    </div>
    <b-container class="topSec">
      <div class="ad">
        <div class="ad" style="text-align:center; height: 150px;">
          <script
            async
            src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
            type="application/javascript"
          ></script>
          <script type="application/javascript">
            window.googletag = window.googletag || { cmd: [] };
            googletag.cmd.push(function() {
              billboardsizes = googletag
                .sizeMapping()
                .addSize([980, 0], [728, 90]) 
                .addSize([0, 0], [320, 50])
                .build();
              googletag
                .defineSlot(
                  "/2835490/New_PGA_Top_Banner_Home",
                  [
                    [970, 250],
                    [320, 50],
                    [728, 90],
                  ],
                  "div-gpt-ad-1568947342181-0"
                )
                .defineSizeMapping(billboardsizes)
                .addService(googletag.pubads());
              googletag.pubads().enableSingleRequest();
              googletag.enableServices();
            });
          </script>

          <!-- /2835490/New_PGA_Top_Banner_Home -->
          <div id="div-gpt-ad-1568947342181-0">
            <script type="application/javascript">
              googletag.cmd.push(function() {
                googletag.display("div-gpt-ad-1568947342181-0");
              });
            </script>
          </div>
        </div>
      </div>
      <b-row>
        <b-col>
          <b-row class="topSecrow">
            <b-col md='6' cols='12'>
              <h2>
                <span v-if="tourom === '99'">PGA Tour Order of Merit</span>
                <span v-if="tourom === '98'">Legends Order of Merit</span>
                <span v-if="tourom === 'N1'">{{ data.full_name }}</span>
                <span v-if="tourom === '81'">{{ data.full_name }}</span>
              </h2>
            </b-col>
            <b-col md='6' cols='12'>
              <b-nav pills>
                <b-dropdown :text="this.id + ' Season'">
                  <b-dropdown-item
                    v-on:click="changeYear"
                    v-for="(seasons,
                    index) in tm_params.seasons.seasons_entry.slice().reverse()"
                    :key="index"
                    :title="seasons.code"
                    :year="seasons.code"
                    >{{ seasons.desc }}</b-dropdown-item
                  >
                </b-dropdown>
                <div
                  v-if="
                    this.tourom === '99' ||
                      this.tourom === '98' ||
                      this.tourom === '0' ||
                      this.tourom === 'T1'
                  "
                ></div>
                <div v-else>
                  <b-dropdown v-if="stats.ooms === ''" :text="'Report'">
                    <b-dropdown-item>No Stats</b-dropdown-item>
                  </b-dropdown>
                  <b-dropdown
                    v-else-if="Array.isArray(stats.ooms.ooms_entry)"
                    :text="data.short_name"
                  >
                    <b-dropdown-item
                      v-for="(ooms, index) in stats.ooms.ooms_entry"
                      :key="index + Math.random()"
                      v-on:click="pickStat"
                      :title="'ooms-oom-' + ooms.code"
                      >{{ ooms.short_name }}</b-dropdown-item
                    >
                  </b-dropdown>
                  <b-dropdown v-else :text="data.short_name">
                    <b-dropdown-item
                      v-on:click="pickStat"
                      :title="'ooms-oom-' + stats.ooms.ooms_entry.code"
                      >{{ stats.ooms.ooms_entry.full_name }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
              </b-nav>
            </b-col>
          </b-row>
          <b-row class="topSecrow">
            <b-col>
              <span class='rookie'><b-img class='tag' :src="config.VUE_APP_ASSETS+'2020/04/Theauer.png'"></b-img> - eligible for TAG Heuer Rookie of the Year</span>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row>
        <b-col>
          <h3 class='noStats' v-if="stats.ooms === ''">
            No Stats For This Season
          </h3>
          <StatsTable v-else :id="id" :stat="stat" :data="data" :config="config"/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import StatsTable from "@/components/statsTable.vue";
import MiniMenu from "@/components/miniMenu.vue";

export default {
  name: "oom",
  components: {
    StatsTable,
    MiniMenu
  },
  props:['config'],
  data() {
    return {
      stats: [],
      id: this.$route.query.id,
      stat: [],
      data: [],
      tm_params: [],
      tourom: this.tourOm(),
    };
  },
  methods: {
    tourOm: function(oom) {
      if (this.$route.query.tour === "aus") oom = "99";
      else if (this.$route.query.tour === "snr") oom = "98";
      else if (this.$route.query.tour === "all") oom = "N1";
      else if (this.$route.query.tour === "trn") oom = "81";
      else oom = "0";
      return oom;
    },
    changeYear: function(event) {
      var id = event.target.getAttribute("title");
      return (
        (this.id = id),
        axios
          .get(
            "https://api.aus.ocs-software.com/pgaaus/cache/" +
              this.$route.query.tour +
              "/" +
              this.id +
              "/tmticx?field=Y&fields=ooms&fields=stats&randomadd=" +
              new Date().getTime()
          )
          .then((response) => {
            this.stats = response.data;
            return axios.get(
              "https://api.aus.ocs-software.com/pgaaus/cache/" +
                this.$route.query.tour +
                "/" +
                this.id +
                "/" +
                this.id +
                "-ooms-oom-" +
                this.tourom +
                ".json?randomadd=" +
                new Date().getTime()
            );
          })
          .then((response) => {
            this.data = response.data;
          })
      );
    },
    pickStat: function(event) {
      var stat = event.target.getAttribute("title");
      return (
        (this.stat = stat),
        axios
          .get(
            "https://api.aus.ocs-software.com/pgaaus/cache/" +
              this.$route.query.tour +
              "/" +
              this.id +
              "/" +
              this.id +
              "-" +
              this.stat +
              ".json?randomadd=" +
              new Date().getTime()
          )
          .then((response) => (this.data = response.data))
      );
    },
  },
  mounted() {
    axios //add API Call
      .get(
        "https://api.aus.ocs-software.com/pgaaus/cache/" +
          this.$route.query.tour +
          "/tmticx?randomadd=" +
          new Date().getTime()
      ) // Page number changed on each page based on JSON page id you are calling
      .then((response) => {
        this.tm_params = response.data;
        return axios.get(
          "https://api.aus.ocs-software.com/pgaaus/cache/" +
            this.$route.query.tour +
            "/" +
            this.$route.query.id +
            "/tmticx?field=Y&fields=ooms&fields=stats&randomadd=" +
            new Date().getTime()
        );
      })
      .then((response) => {
        this.stats = response.data;
        return axios.get(
          "https://api.aus.ocs-software.com/pgaaus/cache/" +
            this.$route.query.tour +
            "/" +
            this.id +
            "/" +
            this.id +
            "-ooms-oom-" +
            this.tourom +
            ".json?randomadd=" +
            new Date().getTime()
        );
      })
      .then((response) => {
        this.data = response.data;
      });
  },
};
</script>

<style scoped>
::v-deep table > thead > tr > th {
  padding: 0.75rem;
}
::v-deep .table th, .table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}
.tRow {
  border-bottom: 1px solid #000;
  padding: 5px 0;
  background: white;
}
.nav {
  float: right;
}
::v-deep button {
  color: black;
  background-color: #dfe1e6;
  border: 1px solid black;
  border-radius: 0;
  width: 250px;
  text-align: left;
}
::v-deep button::after {
  float: right;
  margin-top: 10px;
}
.noStats{
  text-align: center;
}
::v-deep button:hover {
  color: #263056;
  background-color: white;
}
#oomPage {
  background-color: #f9f9f9;
}
.topSec {
  padding-top: 5%;
  padding-bottom: 5%;
}
.topSecrow {
  padding-top: 2%;
}
.tag{
  width: 30px;
}
.rookie{
  padding-left: 15px;
  padding-top: 15px;
  font-size: 11pt;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: 500;
  line-height: 1.1;
}
.ad {
  padding: 15px 0;
}
@media only screen and (max-width: 480px) {
  .nav{
    float: left;
  }
}
</style>
